<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Icon } from '@iconify/vue';

const { locale } = useI18n();
function setLocale(value: string) {
  locale.value = value;
}
const languageDD = ref([
    {
        title: 'Português',
        subtext: 'BR',
        value: 'pt',
        icon: 'emojione:flag-for-brazil'
    },
    {
        title: 'English',
        subtext: 'US',
        value: 'en',
        icon: 'emojione:flag-for-united-states'
    },
    {
        title: 'Español',
        subtext: 'ES',
        value: 'es',
        icon: 'emojione:flag-for-spain'
    }
]);
</script>

<template>
    <!-- ---------------------------------------------- -->
    <!-- language DD -->
    <!-- ---------------------------------------------- -->
    <v-menu :close-on-content-click="false" location="bottom" class="language_dropdown">
        <template v-slot:activator="{ props }">
            <v-btn icon size="small" class="custom-hover-primary" v-bind="props">
                <v-avatar size="24">
                    <Icon v-if="$i18n.locale === 'pt'" icon="emojione:flag-for-brazil" width="24" height="24" />
                    <Icon v-else-if="$i18n.locale === 'en'" icon="emojione:flag-for-united-states" width="24" height="24" />
                    <Icon v-else-if="$i18n.locale === 'es'" icon="emojione:flag-for-spain" width="24" height="24" />
                    <!-- Fallback para português se não houver idioma definido -->
                    <Icon v-else icon="emojione:flag-for-brazil" width="24" height="24" />
                </v-avatar>
            </v-btn>
        </template>

        <v-sheet rounded="md" width="200" elevation="10">
            <v-list class="theme-list">
                <v-list-item
                    v-for="(item, index) in languageDD"
                    :key="index"
                    color="primary"
                    :active="locale === item.value"
                    class="d-flex align-center"
                    @click="setLocale(item.value)"
                >
                    <template v-slot:prepend>
                        <v-avatar size="22">
                            <Icon :icon="item.icon" width="22" height="22" />
                        </v-avatar>
                    </template>
                    <v-list-item-title class="text-subtitle-1 font-weight-regular">
                        {{ item.title }}
                        <span class="text-disabled text-subtitle-1 pl-2">({{ item.subtext }})</span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-sheet>
    </v-menu>
</template>
